import React from 'react';
import styled from 'react-emotion';
import Spinner from './ui/Spinner';
import theme from '@jetshop/ui/utils/theme';

const LoadingPageWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: ${theme('space.3')};
`;
const LoadingPage = () => {
  return (
    <LoadingPageWrapper>
      <Spinner />
    </LoadingPageWrapper>
  );
};

export default LoadingPage;
